<template>
  <div class="categories">
    <v-card-text >
      <div class="chat-list" v-for="item in items" :key="item.Id">
        <v-card  v-on:click="goToDetail(item.Id,item.CategoryGroupTitle)" :color="get_item_color(item.Id)">

          <div class="row" style="margin-top: 0px">
            <div class="col-2" style="padding-right: 0px;align-self: center;">
              <img style="width: 44px;height: 44px" class="rounded-circle" :src="item.ImageUrl"/>
            </div>
            <div class="col-8" style="align-self: center;">
            <span class="name">
              {{item.CategoryGroupTitle}}
            </span>
            </div>
            <div class="col-1" style="align-self: center">
              <v-icon color="#1976d2">
                mdi-chevron-left
              </v-icon>
            </div>
          </div>
        </v-card>

      </div>

    </v-card-text>

  </div>

</template>
<script>
  export default {
    data () {
      return {
        items:[],
        selected_item_id:'',
        errors: [],

      }
    },
watch: {

    },
mounted () {
      var passing_data = JSON.parse(localStorage.getItem('request_data'))
     this.selected_item_id = passing_data.sub_group_id

      this.get_categories()
    },
    methods: {
      get_item_color (item_id) {
        if (item_id == this.selected_item_id) {
          return '#cee2f7'
        } else {
          return 'white'
        }
      },
      goToDetail (item_id, title) {
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.sub_group_id = item_id
        passing_data.request_name = passing_data.request_name + title + ' '

        localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.$router.push({ path: 'brands', params: {} })
      },
      get_categories () {
        // console.log("datas is "+localStorage.getItem('request_data'))

        var self = this
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var group_id = passing_data.group_id
        const send_data = {
          catId: group_id,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetReqCategoryGroupListRelByCatId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("response", response);
              // self.fullName = response.data.msg;
              self.items = response.data.groups
              var json_out = [];
              self.items.forEach(function (val) {
                var my_item = {};
                my_item.ParentId = group_id;
                my_item.Id = val.Id;
                my_item.Name = "تعمیر "+val.CategoryGroupTitle;
                my_item.Image = val.ImageUrl;

                json_out.push(my_item)
              })
              console.log("out cat",JSON.stringify(json_out))
              // self.level = 2;
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      }
    }
  }
</script>
